import functions from '../functions.js';
import Slider from '../components/Slider.js';

$(() => {
    details.init();
});

const details = {
    $form: null,
    form: null,
    params: {
        objectId: null,
        unitId: null,
        guests: null,
        dates: null,
        dateFrom: null,
        dateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
    },
    inquiryRequired: ['dateFrom', 'dateTo', 'firstName', 'lastName', 'email', 'phone', 'guests'],
    focusOnBooking: false,
    calcTotal: 0,
    trackingTotal: 0,

    init() {

        if (! $('.page-type-details')[0]) {
            return;
        }

        this.initItinerarySlider();

        //  read more component
        $('.read-more').each((i, elem) => {
            let $content = $(elem).find('.read-more-content');
            let $close = $(elem).find('.read-more-close');
            let $open = $(elem).find('.read-more-open');
    
            $($open).on('click', function(e) {
                $($content).addClass('no-before expand');
                $(e.currentTarget).addClass('d-none');
                $($close).removeClass('d-none');
            })
    
            $($close).on('click', function(e) {
                $($content).removeClass('expand');
                $(e.currentTarget).addClass('d-none');
                $($open).removeClass('d-none');
    
                $('html, body').stop().animate({
                    scrollTop: $(elem).offset().top - 250
                }, 0);
                setTimeout(function() {
                    $($content).removeClass('no-before');
                }, 500);
    
            });
        });

        details.getParams();

        details.params.objectGroupId = $('#booking').attr('data-objectgroupid');
        details.params.objectId = $('#booking').attr('data-objectid') || null;

        details.calcErrorMessages = $('#booking').attr('data-calcErrorMessages') ? JSON.parse($('#booking').attr('data-calcErrorMessages')) : null;

        details.getCalculation();

        details.inquiryInit();

        $('#booking [name="guests"]').on('change', e => {
            const $target = $(e.currentTarget);

            const unitId = $target.attr('data-unitId');
            details.params.dateFrom = $target.attr('data-dateFrom');
            details.params.dateTo = $target.attr('data-dateTo');
            details.params.guests = $target.val();

            $('.btn-booking[data-unitId="' + unitId + '"]').attr('data-guests', details.params.guests);

            details.getCalculation(unitId);
        });

        $('.btn-booking').on('click', e => {

            const $target = $(e.currentTarget);
            const unitId = $target.attr('data-unitId');
            const dateFrom = $target.attr('data-dateFrom');
            const dateTo = $target.attr('data-dateTo');
            const isBookable = $target.attr('data-isBookable');
            const $unitAlert = $('.alert-booking-params[data-unitId="' + unitId + '"]');

            let guests = $target.attr('data-guests');
            guests = guests && ! guests.startsWith('0') ? guests : null;
            let href = $target.attr('data-href').split('?')[0];

            if(isBookable && guests) {
                href += '?unitId=' + unitId +
                    '&dateFrom=' + dateFrom +
                    '&dateTo=' + dateTo +
                    '&guests=' + guests +
                    '&addAllOptionals=' + 1;

                location = href;
            } else if (! guests) {
                
                if(! $unitAlert.hasClass('active')) {
                    $unitAlert.addClass('active');
            
                    setTimeout(() => {
                        $unitAlert.removeClass('active');
                    }, 4500);
                }
            }

        });
    },  
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    isRequest(data) {
        return !data.isAvailable && data.calc.status == 'Request';
    },
    getCalcErrorMessage(error) {

        if (error && details.calcErrorMessages && details.calcErrorMessages[error.message]) {
            return details.calcErrorMessages[error.message].replace('{$condition}', error.condition);
        }

        const $calcMsg = $('.calc-msg');
        if($calcMsg.length && $calcMsg.attr('data-generaltext')) {
            return $calcMsg.attr('data-generaltext');
        }

        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    getCalculation(unitId = null) {
        const dateFrom = details.params.dateFrom;
        const dateTo = details.params.dateTo;

        details.params.guests = details.params.guests && details.params.guests.startsWith('0') ? null : details.params.guests;

        if (
            (details.params.objectId || unitId)
            && details.params.guests
            && dateFrom
            && dateTo
            && details.params.objectGroupId
        ) {

            //$('.calc-loader').prepend(tplLoader).scrollTop(0);
            //$('.calc-wrapper').css('opacity', 0);
            //$('.calc-wrapper').css('display', 'none');

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + details.params.objectId)
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang()
                + '&addAllOptionals=' + 1
            )
                .done(response => {

                    if (response.status) {
                        const data = response.data || [];

                        Object.entries(data).forEach(unit => {
                            const unitId = unit[0];
                            const unitData = unit[1];
                            const $unit = $('.booking-unit-card[data-unitid=' + unitId + ']');
                            const $btnBooking = $('.btn-booking[data-unitid=' + unitId + ']');
                            const isBookable = details.isBookable(unitData);

                            if (isBookable) {
                                const unitCalc = unitData.calc;

                                const calcItems = unitCalc.items;
                                let priceOld = 0.00;
                                let priceOldEUR = 0.00;
                                let discountTitle = null;

                                calcItems.forEach(item => {
                                    // popust za djecu ne ulazi u prikaz discount cijene
                                    if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                                        priceOld += item.itemTotal;
                                        priceOldEUR += item.itemTotalEUR;
                                    }
                                    if (item.itemType == 'discount') {
                                        discountTitle = item.itemTitle;
                                        if (item.data && item.data.text) {
                                            discountTitle = item.data.text;
                                        }
                                    }
                                });

                                details.calcTotal = unitCalc.total;

                                const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                                const priceOldFormated = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                                const totalEUR = functions.formatMoney(unitCalc.totalEUR, 0, '.', ',') + ' kn';
                                const priceOldEURFormated = functions.formatMoney(priceOldEUR, 0, '.', ',') + ' kn';

                                let guestsText = unitCalc.guests.split(',', 2);
                                guestsText = guestsText.reduce((sum, num) => sum + +num, 0);

                                $unit.find('.label-from').addClass('d-none');

                                $unit.find('.calc-msg').addClass('d-none');

                                $unit.find('.price').removeClass('d-none').html(total);
                                $unit.find('.price-old').removeClass('d-none').html(priceOld && priceOld > unitCalc.total ? priceOldFormated : '');

                                $unit.find('.price-converted').html(totalEUR);
                                $unit.find('.price-old-converted').html(priceOld && priceOld > unitCalc.total ? priceOldEURFormated : '');

                                $unit.find('.label-total').removeClass('d-none');

                                $unit.find('.no-calculation').addClass('d-none');
                                $unit.find('.calculation').removeClass('d-none');
                                $unit.find('.booking-guests').html(guestsText);
                                $unit.find('.booking-nights').html(unitCalc.nights);
                                $unit.find('.booking-period').html(functions.formatDate(dateFrom, 'dd.mm.yyyy.') + ' - ' + functions.formatDate(dateTo, 'dd.mm.yyyy.'));

                            } else {
                                $unit.find('.price').addClass('d-none');
                                $unit.find('.price-old').addClass('d-none');
                                $unit.find('.calc-msg').removeClass('d-none').html(details.getCalcErrorMessage(unitData));

                                $unit.find('.label-from').addClass('d-none');
                                $unit.find('.label-total').addClass('d-none');

                                $unit.find('.no-calculation').removeClass('d-none');
                                $unit.find('.calculation').addClass('d-none');

                                ['.price-old', '.price', '.price-old-converted', '.price-converted'].forEach((elem, i) => {
                                    let $elem = $unit.find(elem);
                                    if ($elem.length) {
                                        let curr = $elem.attr('data-currency');
                                        let price = $elem.attr('data-price');
                                        if (price && price !== '0,00' && price !== '0') {
                                            let formatedPrice = curr + ' ' + price;
                                            if (curr == 'kn') formatedPrice = price + ' ' + curr;
                                            $elem.html(formatedPrice);
                                        }
                                        else {
                                            $elem.html('');
                                        }
                                    }
                                })
                            }

                            
                            if(isBookable) {
                                $btnBooking.attr('data-isBookable', isBookable);
                            } else if(! isBookable) {
                                $btnBooking.attr('data-isBookable', null);
                            }

                            /*setTimeout(() => {
                                let wh = $(window).outerHeight();
                                $('.calc-loader').removeClass('loading').find('.list-loader').remove();
                                $('.calc-wrapper').css('opacity', 1);
                                $('.calc-wrapper').css('display', 'flex');
                                if (functions.isMobile() && details.focusOnBooking) functions.scrollToElement($('.booking-scroll-hook'), wh);
                            }, 450)*/


                        });
                    }

                }).fail(function (error) {
                    console.log(error);
                });
        }

        else {
            $('.no-calculation').removeClass('d-none');
            $('.calculation').addClass('d-none');

            $('.calc-msg').addClass('d-none');
            $('.label-total').addClass('d-none');
            $('.label-from').removeClass('d-none');

            const $price = $('.price[data-unitId="' + unitId + '"]');
            const $priceOld = $('.price-old[data-unitId="' + unitId + '"]');
            $price.text($price.attr('data-price'));
            $priceOld.text($priceOld.attr('data-priceOld'));

            $('.btn-booking[data-unitId="' + unitId + '"]').attr('data-guests', null);
            $('.btn-booking[data-unitId="' + unitId + '"]').attr('data-isBookable', null);
        }
    },
    initItinerarySlider() {
        const $itineraryDaysSlider = $('#itinerary-days-slider');
        const $itinerarySlider = $('#itinerary-slider');

        if( $itineraryDaysSlider.length) {
            $itineraryDaysSlider._slider = new Slider($itineraryDaysSlider, {
                rubberband: false,
                loop: false,
                drag: true,
                arrows: true,
                pager: false,
                //mode: "snap",
                //rtl: false,
                slides: {
                    perView: 'auto',
                    spacing: 12
                },
                defaultAnimation: {
                    duration: 0
                },
                /*detailsChanged: (s) => {
                    s.slides.forEach((element, idx) => {
                        if ( s.track.details.slides[idx].portion == 1 ) {
                            $itinerarySlider._slider.instance.moveToIdx(idx);
                        }
                    })
                },*/
            });
        }

        if ( $itinerarySlider.length ) {    
            $itinerarySlider._slider = new Slider($itinerarySlider, {
              fade: false,
              rubberband: false,
              loop: true,
              arrows: false,
              pager: false,
              slides: {
                perView: 1,
                spacing: 0
              },
              defaultAnimation: {
                duration: 0
            },
              detailsChanged: (s) => {
                if( $itineraryDaysSlider.length ) {
                    s.slides.forEach((element, idx) => {
                        if ( s.track.details.slides[idx].portion == 0 ) {
                            $($itineraryDaysSlider.find('.keen-slider__slide')[idx]).removeClass('active');
                            //$itineraryDaysSlider.find('.keen-slider__slide').removeClass('active');
                        }
    
                        if ( s.track.details.slides[idx].portion == 1 ) {
                            $itineraryDaysSlider._slider.instance.moveToIdx(idx);
                            $($itineraryDaysSlider.find('.keen-slider__slide')[idx]).addClass('active');
                        }
                    });
                }
              },
            });
        }

        if( $itineraryDaysSlider.length ) {
            $itineraryDaysSlider.find('.keen-slider__slide').on('click', e => {
                const $target = $(e.currentTarget);
                const $slides = $itineraryDaysSlider.find('.keen-slider__slide');
    
                $slides.removeClass('active');
                $target.addClass('active');
    
                const index = $slides.index($target);
                $itinerarySlider.length && $itinerarySlider._slider.instance.moveToIdx(index);

                this.closeItineraryReadMore();
            });
        }

        $('.itinerary-slider-container').find('[data-dir]').on('click', e => {
            const $target = $(e.currentTarget);
            const dir = $target.attr('data-dir');

            if(dir == 'prev') {
                $itinerarySlider._slider.instance.prev();
            } else {
                $itinerarySlider._slider.instance.next();
            }

            this.closeItineraryReadMore();
        });
    },
    closeItineraryReadMore() {
        $('.itinerary-card .read-more').each((i, elem) => {
            const $close = $(elem).find('.read-more-close');
            ! $close.hasClass('d-none') && $close.trigger('click');
        });
    },
    inquiryInit() {

        const $formInquiry = $('form#inquiry');

        $('.btn-request-modal').on('click', e => {
            const $target = $(e.currentTarget);
            const modalId = $target.attr('data-bs-target');
            const unitId = $target.attr('data-unitId');
            const dateFrom = $target.attr('data-dateFrom');
            const dateTo = $target.attr('data-dateTo');

            $formInquiry.find('[name="unitId"]').val(unitId);
            $formInquiry.find('[name="dateFrom"]').val(dateFrom);
            $formInquiry.find('[name="dateTo"]').val(dateTo);

            $(modalId).modal('show');
        });

        $formInquiry.on('submit', e => {
            e.preventDefault();

            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            let allParams = $(e.currentTarget).serializeArray();
            $.each(allParams, function (i, field) {
                params[field.name] = field.value;
            });

            functions.setFormData($('form#inquiry'), params);
            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            params['recaptchaType'] = 'enterprise';

            grecaptcha.enterprise.ready(function () {
                grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {

                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);

                    $.post('/services/inquiry', params).then(response => {
                        response = JSON.parse(response);
                        const $requestAlert = $('.request-alert');

                        if(response.status) {
                            $requestAlert.removeClass('alert-danger');
                            $requestAlert.addClass('alert-success');
                        } else {
                            $requestAlert.removeClass('alert-success');
                            $requestAlert.addClass('alert-danger');
                        }

                        $requestAlert.html(response.data).removeClass('d-none');

                        setTimeout(() => {
                            $('.contact-btn').removeClass('d-none');
                            $('.contact-spinner').addClass('d-none');
                            $('.contact-spinner').removeClass('d-flex');
                            //$(".request-error, .request-success").addClass('d-none');
                        }, 1500);

                        // $(".request-error, .request-success").addClass('d-none');
                        $('.request-form').on('hide.bs.modal', e => {
                            //$('.request-error, .request-success').addClass('d-none');
                            $requestAlert.addClass('d-none');
                        });

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }
                    });
                });
            });
        });
    },
}